import type { GpuContext } from '../context.js';
import { workgroupCount } from '../context.js';
import type { GpuImage } from '../resources.js';
import { Struct } from '../uniform-writer.js';
import { FORMAT_WGSL_TEXEL } from '../types.js';

/** Fills a texture with a constant. Works for every format the pipeline uses. */
export function fillImage(
  ctx: GpuContext,
  dst: GpuImage,
  value: readonly [number, number, number, number],
): void {
  ctx.dispatch(
    {
      module: 'fill.wgsl',
      defines: { DST_FORMAT: dst.format, TEXEL: FORMAT_WGSL_TEXEL[dst.format] },
      bindings: [{ kind: 'storageTexture', format: dst.format }, { kind: 'uniform' }],
    },
    [
      dst,
      ctx.uniform(new Struct(32).i(0, dst.width, dst.height).f(16, ...value).bytes),
    ],
    [workgroupCount(dst.width, 8), workgroupCount(dst.height, 8)],
    `fill ${dst.format}`,
  );
}
